import React from "react";
import { useLanguage } from "../Router/LanguageContext";

export default function PeopleSafetyExecution() {
  const { dictionary } = useLanguage();

  const executionData = [
    {
      icon: "/assets/img/TechnicalteamsIcon.svg",
      title: dictionary?.technicalTeamsTitle,
      description: dictionary?.technicalTeamsDesc,
    },
    {
      icon: "/assets/img/TrainingIcon.svg",
      title: dictionary?.trainingTitle,
      description: dictionary?.trainingDesc,
    },
    {
      icon: "/assets/img/SafetyIcon.svg",
      title: dictionary?.safetyTitle,
      description: dictionary?.safetyDesc,
    },
    {
      icon: "/assets/img/ResponsibilityIcon.svg",
      title: dictionary?.responsibilityTitle,
      description: dictionary?.responsibilityDesc,
    },
  ];

  return (
    <div className="container-fluid maxContainerSection commonPadding">
      <div className="row">
        <div className="col-md-6">
          <img
            src="/assets/img/safetyexecution.png"
            alt=""
            className="img-fluid"
          />
        </div>

        <div className="col-md-6 executionSection">
          <div>
            <div className="executionHeaderSec">
              <h3 className="m-0 f-s-48">
                {dictionary?.peopleSafetyExecutionTitle}
              </h3>

              <p className="m-0 f-s-20">
                {dictionary?.peopleSafetyExecutionDesc}
              </p>
            </div>

            <div>
              {executionData.map((item, index) => (
                <div className="executionPoints" key={index}>
                  <div>
                    <img src={item.icon} alt="" />
                  </div>

                  <div>
                    <h6 className="m-0 f-s-20">{item.title}</h6>
                    <p className="m-0 f-s-16">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}